import React from 'react';
import type { TreeMenuItem, useLink } from '@refinedev/core';
import { blockOf, getFirstNavigableRoute, getIcon, isTreeItemActive, startsBlock } from './helpers';
import * as Styles from './styles';

type LinkComponent = ReturnType<typeof useLink>;

type Props = {
  items: Array<TreeMenuItem>;
  selectedKey?: string | null;
  Link: LinkComponent;
  onItemEnter?: (el: HTMLDivElement, key: string) => void;
  onItemLeave?: (key: string) => void;
};

const TopLevelItems: React.FC<Props> = ({ items, selectedKey, Link, onItemEnter, onItemLeave }) => {
  return (
    <Styles.ItemsList>
      {items.map((item, index) => {
        const isActive = isTreeItemActive(item, selectedKey);
        const IconNode = getIcon(item);
        const route =
          item.children && item.children.length
            ? getFirstNavigableRoute(item.children[0]) || getFirstNavigableRoute(item) || ''
            : getFirstNavigableRoute(item) || '';
        return (
          <React.Fragment key={item.key}>
            {startsBlock(items, index) && (
              <Styles.BlockLabel title={blockOf(item).label}>
                {blockOf(item).short}
              </Styles.BlockLabel>
            )}
            <div
              title={String(item.label ?? item.name ?? '')}
              aria-label={String(item.label ?? item.name ?? '')}
              onMouseEnter={e => onItemEnter?.(e.currentTarget as HTMLDivElement, item.key)}
              onMouseLeave={() => onItemLeave?.(item.key)}
            >
              <Link to={route ?? ''} style={{ color: 'inherit' }}>
                <Styles.Item $active={isActive}>
                  <Styles.ItemIcon>{IconNode}</Styles.ItemIcon>
                  <Styles.ItemLabel>{item.label ?? item.name}</Styles.ItemLabel>
                </Styles.Item>
              </Link>
            </div>
          </React.Fragment>
        );
      })}
    </Styles.ItemsList>
  );
};

export default TopLevelItems;
